// MG_DIARYSCAN: размер упаковки из строки вроде «930мл» или «4.5г x 4 шт».
//
// В дневник еду вносят целыми упаковками: выпил бутылку йогурта, съел пачку
// чипсов. Справочник сети хранит фасовку строкой рядом с товаром, так что
// количество можно подставить сразу — человеку останется только поправить,
// если съел половину.
//
// Миллилитры считаем граммами: для напитков разница в пределах процентов, а
// альтернатива — заставить человека пересчитывать самому.

const MULTIPLIERS: Record<string, number> = {
  г: 1,
  гр: 1,
  g: 1,
  мл: 1,
  ml: 1,
  кг: 1000,
  kg: 1000,
  л: 1000,
  l: 1000,
};

/** Граммы из строки фасовки. null — если размер не читается («упак», «шт»). */
export const packageGrams = (text: string | null | undefined): number | null => {
  const raw = String(text ?? '')
    .toLowerCase()
    .replace(',', '.');
  if (!raw) return null;

  // Не \b на конце: границу слова JS считает по латинице, и после «г» она не
  // срабатывает — «250г» не находилось вовсе. Проверяем явно: дальше не буква.
  const m = raw.match(/(\d+(?:\.\d+)?)\s*(кг|kg|мл|ml|гр|г|g|л|l)(?![а-яёa-z])/);
  if (!m) return null;

  const amount = parseFloat(m[1]) * (MULTIPLIERS[m[2]] ?? 1);
  if (!Number.isFinite(amount) || amount <= 0) return null;

  // «4.5г x 4 шт» — пачка из четырёх пакетиков: в дневник идёт вся пачка.
  // Множитель бывает и кириллической «х» — на этикетках их не различают.
  const packs = raw.slice(m.index! + m[0].length).match(/^\s*[xх×*]\s*(\d+)/);
  const total = packs ? amount * parseInt(packs[1], 10) : amount;

  return total > 0 && total <= 20000 ? Math.round(total) : null;
};
